import { MRT_ColumnDef } from "material-react-table"
import { useMemo, useState } from "react"
import { useApiQuery } from "../../../../../core/api/useApiQuery"
import { useAppLocalization } from "../../../../localization/components/AppLocalizationProvider"
import {
    AccountingQuery,
    fetchCustomerBalanceReportByPeriod,
    FetchCustomerBalanceReportResponse,
    UserBalance,
} from "../accountingApi"
import { ExportButtonCustomerBalance } from "./ExportButtonCustomerBalance"
import { useMerchant } from "../../../../merchants/merchantHooks"
import { TableSummaryWrap, TableTotalAmountBox } from "../../../../../shared/components/table/TableSummaryBox"
import { StandardTableFilter } from "../../../../../shared/components/table/StandardTableFilters"
import { useApiQueryTable } from "../../../../../core/api/components/ApiQueryTable"
import { StandardCustomerSelect } from "../../../../../shared/components/filters/components/StandardCustomerSelect"

type UserBalanceTabProps = Readonly<{}>
const transformData = (data: FetchCustomerBalanceReportResponse) => data?.usersBalance || []

export function UserBalanceTab({}: UserBalanceTabProps) {
    const { l10n } = useAppLocalization()

    const [customerId, setCustomerId] = useState<string>()
    const [customerGroupId, setCustomerGroupId] = useState<string>()

    const { merchantId } = useMerchant()

    const customerBalanceReport = useApiQuery(fetchCustomerBalanceReportByPeriod, {
        queryName: AccountingQuery.USER_BALANCE_LIST,
        dependencies: {
            merchantId,
            customerId,
            customerGroupId,
        },
        select: transformData,
    })

    const { ApiQueryTable, columnFactory } = useApiQueryTable(customerBalanceReport)

    const columns = useMemo<MRT_ColumnDef<UserBalance>[]>(
        () => [
            columnFactory.idColumn({
                header: l10n.getString("employee-id"),
                accessorKey: "user.employeeId",
            }),
            columnFactory.shortNameColumn({
                header: l10n.getString("name"),
                accessorKey: "user.displayName",
            }),
            columnFactory.shortNameColumn({
                header: l10n.getString("email"),
                accessorKey: "user.email",
            }),
            columnFactory.moneyColumn(
                {
                    header: l10n.getString("amount"),
                    id: "totalAmount",
                },
                (row) => row.totalAmount,
                true,
            ),
        ],
        [],
    )

    return (
        <ApiQueryTable
            columns={columns}
            enableRowActions={false}
            initialState={{ density: "spacious" }}
            renderToolbarInternalActions={({ table }) => (
                <StandardTableFilter variant="right" table={table}>
                    <ExportButtonCustomerBalance data={customerBalanceReport.data || []} />
                </StandardTableFilter>
            )}
            renderTopToolbarCustomActions={() => (
                <StandardTableFilter variant="left">
                    <StandardCustomerSelect
                        setCustomerId={setCustomerId}
                        setCustomerGroupId={setCustomerGroupId}
                        customerId={customerId}
                        customerGroupId={customerGroupId}
                    />
                </StandardTableFilter>
            )}
            renderBottomToolbarCustomActions={({ table }) => (
                <TableSummaryWrap padding="sm">
                    <TableTotalAmountBox
                        data={table.getFilteredRowModel().rows}
                        accessor={(row) => row.original.totalAmount}
                    />
                </TableSummaryWrap>
            )}
        />
    )
}
